/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileRvt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M14.414 2H4v20h16v-3h-2v1H6V4h7v5h5v1h2V7.586zm2.172 5H15V5.414z" />
        <path d="M8.925 17v-4.87h1.87c.58 0 1.027.133 1.34.401s.469.648.469 1.14c0 .343-.09.636-.268.877a1.416 1.416 0 0 1-.744.516L12.812 17h-1.153l-1.032-1.749-.663-.167V17zm1.039-2.6h.509c.406 0 .688-.051.844-.154.161-.107.241-.292.241-.556s-.08-.447-.24-.55c-.157-.106-.438-.16-.845-.16h-.51zm4.745 2.6-1.796-4.87h1.18l1.138 3.584 1.153-3.585h1.132L15.72 17zm4.582-3.986V17h1.045v-3.986h1.44v-.885h-3.925v.885z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileRvt as FileRvt };
